import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { Button, media } from '@/shared/components';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { RemindersSentModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const RemindersSentModal: FC<RemindersSentModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'remindersSent' });
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  const handleSubmit = () => {
    modals.closeModal();
  };

  return (
    <ModalContainerV2 title={t('title')} pinBottom={true}>
      <DescriptionWrapper>{t('description')}</DescriptionWrapper>
      <ButtonWrapper>
        <Button text={t('confirmButton')} isBlock={!isDesktop} onClick={handleSubmit} />
      </ButtonWrapper>
    </ModalContainerV2>
  );
};

const DescriptionWrapper = styled.div`
  padding: 24px 0px;
  white-space: pre-line;

  ${media.mobile} {
    padding: 16px 0px 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`;
